import type { UpdateReservedSlugsBody } from '@planuze/admin-contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getReservedSlugs, updateReservedSlugs } from '../lib/reserved-slugs-api.js';

/* Hooks dos slugs reservados (ADR-0484). A lista alimenta o painel de gestão E o Select do
   provision (mesma queryKey → um só fetch, invalidação única após editar). */

export function useReservedSlugs() {
  return useQuery({ queryKey: ['reserved-slugs'], queryFn: () => getReservedSlugs() });
}

export function useUpdateReservedSlugs() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateReservedSlugsBody) => updateReservedSlugs(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reserved-slugs'] });
    },
  });
}
